export default "__VITE_ASSET__CKjiQT6M__"